var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrierPaymentFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carrier_Payment",
    "data-name": "Carrier Payment",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Invoice",
    transform: "translate(80 230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M4.565,1A1.565,1.565,0,0,0,3,2.565V19H16.3V2.565A1.565,1.565,0,0,1,17.87,1Zm5.478,6.261H9.261A1.174,1.174,0,0,1,8.087,6.087V5.7A1.174,1.174,0,0,1,9.261,4.522V4.13a.391.391,0,1,1,.783,0v.391c1.174,0,1.534,1.565.783,1.565a.391.391,0,0,1-.391-.391.391.391,0,0,0-.391-.391H9.261A.391.391,0,0,0,8.87,5.7v.391a.391.391,0,0,0,.391.391h.783a1.174,1.174,0,0,1,1.174,1.174v.391a1.174,1.174,0,0,1-1.174,1.174v.391a.391.391,0,0,1-.783,0V9.217c-1.174,0-1.534-1.565-.783-1.565a.391.391,0,0,1,.391.391.391.391,0,0,0,.391.391h.783a.391.391,0,0,0,.391-.391V7.652A.391.391,0,0,0,10.043,7.261Zm3.913,9.783H5.348a.391.391,0,1,1,0-.783h8.609a.391.391,0,1,1,0,.783Zm0-1.957H5.348a.391.391,0,0,1,0-.783h8.609a.391.391,0,0,1,0,.783Zm0-1.957H5.348a.391.391,0,0,1,0-.783h8.609a.391.391,0,1,1,0,.783Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M40.174,3A1.174,1.174,0,0,0,39,4.174V5.348h2.348V4.174A1.174,1.174,0,0,0,40.174,3Z",
    transform: "translate(-21.913 -1.217)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierPaymentFill);
export default __webpack_public_path__ + "static/media/carrierPaymentFill.c7f0129647ef320197deeab5eb614a39.svg";
export { ForwardRef as ReactComponent };